import { onlineManager } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

export function useIsOnline() {
  const [isOnline, setIsOnline] = useState(onlineManager.isOnline());

  useEffect(() => {
    const unsubscribe = onlineManager.subscribe(() => {
      const nextIsOnline = onlineManager.isOnline();
      setIsOnline((prev) => (prev !== nextIsOnline ? nextIsOnline : prev));
    });
    return unsubscribe;
  }, []);

  return isOnline;
}
